export default __webpack_public_path__ + "static/media/bookmark.7b9d7db7.svg";